import { apiRequestDev } from './apiRequest';

export const getAllCities = async (config) => apiRequestDev(config, '/cities/all');
